import { Product } from '../types';

export interface DetailEventSetup {
  actionField?: {
    list: string;
  };
  products: Product[];
}

export interface DetailGtmEvent {
  ecommerce: {
    detail: {
      actionField?: {
        list: string;
      };
      products: Product[];
    };
  };
}

export const detail = (eventSetup: DetailEventSetup) => {
  const { dataLayer } = window;

  if (!dataLayer) {
    return;
  }

  const { actionField, products } = eventSetup;

  dataLayer.push({ ecommerce: null });

  const newData: DetailGtmEvent = {
    ecommerce: {
      detail: {
        products,
      },
    },
  };

  if (actionField) {
    newData.ecommerce.detail.actionField = actionField;
  }

  dataLayer.push(newData);
};
